import request from '@/utils/request';
import { tansParams } from '@/utils/method';

// 获取课程列表
export function getCoursesList(query) {
  return request({
    url: '/home/course/list',
    method: 'get',
    params: query,
  });
}

// 获取课程详情
export function getCoursesInfo(courseId) {
  return request({
    url: '/home/course/details/' + courseId,
    method: 'get',
  });
}

// 获取课堂目录
export function getCourseDict(query) {
  return request({
    url: '/home/edu/requestUrl',
    method: 'post',
    data: {
      url: '/tanqi/home/subject/dict/all?' + tansParams(query),
      method: 'get',
    },
    headers: {
      CasToken: '123',
    },
  });
}
// 获取教学管理配置
export function getConfigKey(query) {
  return request({
    url: '/home/edu/requestUrl',
    method: 'post',
    data: {
      url: '/tanqi/home/system/config/list?' + tansParams(query),
      method: 'get',
    },
    headers: {
      CasToken: '123',
    },
  });
}
